import PlaceOrderTermsModal from 'components/GlobalModals/PlaceOrderTermsModal/PlaceOrderTermsModal';
import withGlobalModals from 'hocs/withGlobalModals';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import CheckoutActions from 'actions/CheckoutActions';
import OrderActions from 'actions/OrderActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { orderSelector } from 'selectors/order/orderSelector';
import Empty from 'constants/empty';
import PlaceOrderTermsModalEN from 'components/GlobalModals/PlaceOrderTermsModal/locales/PlaceOrderTermsModal_en_US';
import PlaceOrderTermsModalFR from 'components/GlobalModals/PlaceOrderTermsModal/locales/PlaceOrderTermsModal_fr_CA';

const { wrapHOC } = FrameworkUtils;

const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const { showPlaceOrderTermsModal } = CheckoutActions;

const getText = getLocalisedDataFromResource(PlaceOrderTermsModalEN, PlaceOrderTermsModalFR);

const localizationSelector = createStructuredSelector({
    title: getTextFromResource(getText, 'title'),
    placeOrder: getTextFromResource(getText, 'placeOrder'),
    cancel: getTextFromResource(getText, 'cancel'),
    text: getTextFromResource(getText, 'text'),
    arOnlyTitle: getTextFromResource(getText, 'arOnlyTitle'),
    arOnlyText: getTextFromResource(getText, 'arOnlyText'),
    arSubscriptionTitle: getTextFromResource(getText, 'arSubscriptionTitle'),
    arSubscriptionHeader: getTextFromResource(getText, 'arSubscriptionHeader'),
    arSubscriptionScript: getTextFromResource(getText, 'arSubscriptionScript', [
        '{INSERT FREQUENCY}',
        '{INSERT PRICE}',
        '{INSERT QUANTITY}',
        '{INSERT ITEM}',
        '{INSERT PRODUCT NAME}',
        '{INSERT PRODUCT NAME}'
    ]),
    arsduText: getTextFromResource(getText, 'arsduText'),
    itemsOrder: getTextFromResource(getText, 'itemsOrder'),
    estimatedOrderTotal: getTextFromResource(getText, 'estimatedOrderTotal'),
    deliveryEvery: getTextFromResource(getText, 'deliveryEvery'),
    sduLink: getTextFromResource(getText, 'sduLink'),
    and: getTextFromResource(getText, 'and'),
    arLink: getTextFromResource(getText, 'arLink'),
    arsduText2: getTextFromResource(getText, 'arsduText2'),
    sduTrialTitle: getTextFromResource(getText, 'sduTrialTitle'),
    afterSduTrialTitle: getTextFromResource(getText, 'afterSduTrialTitle'),
    sduTrialScriptHeader: getTextFromResource(getText, 'sduTrialScriptHeader'),
    afterSduTrialScriptHeader: getTextFromResource(getText, 'afterSduTrialScriptHeader'),
    sduTrialScript: getTextFromResource(getText, 'sduTrialScript'),
    afterSduTrialScript: getTextFromResource(getText, 'afterSduTrialScript')
});

const fields = createSelector(orderSelector, localizationSelector, (order, localization) => {
    const { acceptAutoReplenishTerms, confirmVerbalConsent, acceptSDUTerms, orderDetails } = order;
    const sduSubscriptions = orderDetails?.items?.items.filter(subscription => subscription.sku.type === 'SDU')[0];
    const orderItems = orderDetails?.items?.items.filter(item => item.sku.type !== 'SDU' && item.isReplenishment);
    const { orderTotal, storeCardAmount, creditCardAmount } = orderDetails?.priceInfo || Empty.Object;
    const sduTrialEligible = sduSubscriptions?.sku.trialEligible;
    const sduResources = sduTrialEligible
        ? {
            title: localization.sduTrialTitle,
            header: localization.sduTrialScriptHeader,
            script: localization.sduTrialScript
        }
        : {
            title: localization.afterSduTrialTitle,
            header: localization.afterSduTrialScriptHeader,
            script: localization.afterSduTrialScript
        };

    return {
        localization,
        acceptAutoReplenish: acceptAutoReplenishTerms,
        confirmVerbalConsent: confirmVerbalConsent,
        acceptSDUTerms,
        sduScriptTitle: sduResources.title,
        sduScriptHeader: sduResources.header,
        sduScript: sduResources.script,
        orderItems,
        orderTotal: storeCardAmount ? creditCardAmount : orderTotal
    };
});

const functions = {
    showPlaceOrderTermsModal,
    updateSDUTerms: OrderActions.updateSDUTerms,
    updateAutoReplenishTerms: OrderActions.updateAutoReplenishTerms,
    updateVerbalConsent: OrderActions.updateVerbalConsent
};

const withPlaceOrderTermsModalProps = wrapHOC(connect(fields, functions));

export default withGlobalModals(withPlaceOrderTermsModalProps(PlaceOrderTermsModal));
